import React, {Component} from 'react';
import { saveRow } from './SaveCollaborator';
const excludedAttributes = ['createdAt', 'updatedAt', 'index', 'userId'];

class MoreEditor extends Component {
    constructor(props) {
        super(props);
        this.saveData = this.saveData.bind(this);
        this.state = {
            collaborator: props.row,
            open: true
        };
    }

    close = () => {
        this.setState({ open: false });
        this.props.onUpdate(this.props.defaultValue);
    };

    componentDidUpdate() {}

    saveData = () => {
        saveRow(this.state.collaborator, this.props.updateCollaborator);
        this.setState({ open: false });
        this.props.onUpdate(this.props.defaultValue);
    }

    objToArr = obj => {
        let dataArr = [];
        for (let k of Object.keys(obj)) {
            if(!excludedAttributes.includes(k)) {
                dataArr.push([k, obj[k]]);
            }
        }
        return dataArr;
    };

    render() {
        const fullName = this.state.collaborator.first + ' ' + this.state.collaborator.last;
        const fadeIn = this.state.open ? 'in' : '';
        const display = this.state.open ? 'block' : 'none';
        const collaboratorData = this.objToArr(this.state.collaborator).map(map => (
                <div className="form-group" key={map[0] + '_form-group'}>
                    <table width={'100%'}>
                        <tbody>
                        <tr width={'100%'}>
                            <td width={'25%'}>
                                <label key={map[0] + '_label'} htmlFor={`collaborator-${map[0]}`}
                                       className={'form-control-label'}> {map[0]}:</label>
                            </td>
                            <td width={'75%'}>
                                <input ref={`${map.key}-inputRef`}
                                       className={( this.props.editorClass || '') + ' form-control editor edit-text'}
                                       style={{display: 'inline', width: '100%'}}
                                       type='text'
                                       key={map[0]}
                                       defaultValue={map[1]}
                                       id={`collaborator-${map.key}`}
                                       onBlur={
                                           e => {
                                               const clone = Object.assign({}, this.state);
                                               clone.collaborator[`${map[0]}`] = e.currentTarget.value;
                                               this.setState({clone});
                                           }
                                       }
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
        ));

        return (
            <div className={ `modal fade ${fadeIn}` } id='moreModal' role='dialog' style={ { display } }>
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        <div className="modal-header">
                            <h4 className="modal-title">Edit information for {fullName}</h4>
                        </div>
                        <div className='modal-body'>
                            { collaboratorData }
                        </div>
                        <div className='modal-footer'>
                            <button type='button' className='btn btn-primary' onClick={ this.saveData }>Save</button>
                            <button type='button' className='btn btn-default' onClick={ this.close }>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MoreEditor;


// WEBPACK FOOTER //
// ./src/containers/MoreEditor.js